__turbopack_context__.v({
  "acheivername": "prelims-module__jxHLtW__acheivername",
  "acheiverrank": "prelims-module__jxHLtW__acheiverrank",
  "admincontent": "prelims-module__jxHLtW__admincontent",
  "badge": "prelims-module__jxHLtW__badge",
  "circleGlow": "prelims-module__jxHLtW__circleGlow",
  "classesborder": "prelims-module__jxHLtW__classesborder",
  "description": "prelims-module__jxHLtW__description",
  "directionline": "prelims-module__jxHLtW__directionline",
  "featureCard": "prelims-module__jxHLtW__featureCard",
  "featureGrid": "prelims-module__jxHLtW__featureGrid",
  "greybackground": "prelims-module__jxHLtW__greybackground",
  "heading3d": "prelims-module__jxHLtW__heading3d",
  "heroCard": "prelims-module__jxHLtW__heroCard",
  "normalbutton": "prelims-module__jxHLtW__normalbutton",
  "pagemaintitle": "prelims-module__jxHLtW__pagemaintitle",
  "redunderline": "prelims-module__jxHLtW__redunderline",
  "roadmap": "prelims-module__jxHLtW__roadmap",
  "roadmapContainer": "prelims-module__jxHLtW__roadmapContainer",
  "roadmapLine": "prelims-module__jxHLtW__roadmapLine",
  "roadmapStart": "prelims-module__jxHLtW__roadmapStart",
  "roadmapStep": "prelims-module__jxHLtW__roadmapStep",
  "roadmapStep3": "prelims-module__jxHLtW__roadmapStep3",
  "roadmaphead": "prelims-module__jxHLtW__roadmaphead",
  "rotateGlow": "prelims-module__jxHLtW__rotateGlow",
  "statCircle": "prelims-module__jxHLtW__statCircle",
  "statsRow": "prelims-module__jxHLtW__statsRow",
  "stepNumber": "prelims-module__jxHLtW__stepNumber",
  "title": "prelims-module__jxHLtW__title",
  "whyboxboxheight": "prelims-module__jxHLtW__whyboxboxheight",
});
